import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

const StakingMovementFormSchema = yup
	.object({
		createdAt: yup.date().default(undefined),
		ticker: yup.string().default(''),
		term: yup.number().default(undefined),
	})
	.defined();

export type StakingMovementFormData = yup.TypeOf<typeof StakingMovementFormSchema>;

export function useStakingMovementForm() {
	return useForm<StakingMovementFormData>({
		mode: 'all',
		criteriaMode: 'all',
		resolver: yupResolver(StakingMovementFormSchema),
		defaultValues: StakingMovementFormSchema.cast({}),
	});
}
